define([
    "dojo/_base/declare",
    "csi/heading/String",
    "./CareSymbolRendererMixin"
], function(declare,StringRen,CareSymbolRendererMixin) {

    return declare([StringRen, CareSymbolRendererMixin], {

    });
});